import i18next from "i18next";

import type { TranslateFn } from "./useTranslation/useTranslation";

/**
 * Translate outside a React component: react-router form actions and loaders, validation
 * schemas built at module scope, API error mapping. Reads the active language when it is called
 * and re-renders nothing, so a component never uses it for copy it renders — that copy would go
 * stale when the language switches. Components use {@link useTranslation} and pass its `t` down.
 */
export const translate: TranslateFn = (key, params) => i18next.t(key, params);
